export default __webpack_public_path__ + "images/16_1_image.jpg";